var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"column":""}},[_c('h1',{staticClass:"display-1 my-4 text-xs-center"},[_vm._v("Listings")]),_vm._v(" "),_c('listings-map')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }